import { useFormContext } from '@calendly/form'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { ProTip } from '@calendly/ui/components/pro-tip'
import { SwitchInput } from '@calendly/ui/components/switch-input'
import { BodyText, HeadingText } from '@calendly/ui/components/typography'
import { useSelector } from 'react-redux'

import { isManagedEventTypeLockingFeatureEnabledSelector } from 'features/managed_event_types'
import { hasLockingRule } from 'services/event_type_locking'

import { ListItem, SectionLockContainer, SectionLockInputLabel, UnorderedList } from '../styles'

const ProTipBody = () => (
  <>
    <BodyText size="medium">
      {HtmlParser(I18n.t('publisher.event_type_editor.section_lock.allow_text'))}
    </BodyText>
    <br />
    <BodyText size="medium">
      {HtmlParser(I18n.t('publisher.event_type_editor.section_lock.disable_text'))}
    </BodyText>
    <UnorderedList>
      <ListItem>
        {HtmlParser(I18n.t('publisher.event_type_editor.section_lock.disable_edit_note'))}
      </ListItem>
      <ListItem>
        {I18n.t('publisher.event_type_editor.section_lock.disable_sync_note')}
      </ListItem>
    </UnorderedList>
  </>
)

// If rule name is included, display the toggle as off (cannot edit)
// On toggling on (can edit), remove the rule name.
// On toggling off, add the new rule name.
export const LockingRuleSwitch = ({ title, level = 1, ruleName }) => {
  const isLockingFeatureEnabled = useSelector(isManagedEventTypeLockingFeatureEnabledSelector)
  const { values: { lockingRules }, setFieldValue, setFieldTouched } = useFormContext()

  const onChange = (value) => {
    if (value) {
      setFieldValue('lockingRules', lockingRules.concat({ name: ruleName }))
    } else {
      setFieldValue('lockingRules', lockingRules.filter(({ name }) => ruleName !== name))
    }

    setFieldTouched('lockingRules')
  }

  const isLockedValue = hasLockingRule(lockingRules, ruleName)
  const isLocked = isLockingFeatureEnabled && isLockedValue

  if (!isLockingFeatureEnabled) { return null }

  return (
    <>
      {title && (
        <HeadingText level={level}>
          {title}
        </HeadingText>
      )}
      <SectionLockContainer htmlFor={`section_lock_${ruleName}`} aria-label={I18n.t('publisher.event_type_editor.section_lock.label')}>
        <SectionLockInputLabel>
          <BodyText weight="normal">
            {I18n.t('publisher.event_type_editor.section_lock.title_v3')}
          </BodyText>
          <ProTip hideControls>
            <ProTipBody />
          </ProTip>
        </SectionLockInputLabel>

        <SwitchInput
          id={`section_lock_${ruleName}`}
          name={`section_lock_${ruleName}`}
          checked={!isLocked}
          onChange={() => onChange(!isLocked)}
        />
      </SectionLockContainer>
    </>
  )
}
